/*
  this is the place to calculate the new state, based on the action (type and payload) provided

  eg:

  export const addItem = item => ({type: ADD_ITEM, payload: {id: val, arg1: val, arg2: val} })
*/

import { combineReducers } from 'redux'

import authReducer from './authReducer'
import pathReducer from './pathReducer'
import paymentsReducer from './paymentsReducer'
import preferencesReducer from './preferencesReducer'
import prospectsReducer from './prospectsReducer'
import progressReducer from './progressReducer'
import questionsReducer from './questionsReducer'
import skillsReducer from './skillsReducer'
import tagsReducer from './tagsReducer'
import templatesReducer from './templatesReducer'
import usersReducer from './usersReducer'
import viewportReducer from './viewportReducer'
import feedbackReducer from './feedbackReducer'
import couponsReducer from './couponsReducer'
import testsReducer from './testsReducer'
import graphReducer from './graphReducer'
import competenciesReducer from './competenciesReducer'
import businessesReducer from './businessesReducer'
import vouchersReducer from './vouchersReducer'
import busersReducer from './busersReducer'

const appReducer = combineReducers({
  auth: authReducer,
  path: pathReducer,
  payment: paymentsReducer,
  preference: preferencesReducer,
  progress: progressReducer,
  prospect: prospectsReducer,
  question: questionsReducer,
  skill: skillsReducer,
  tag: tagsReducer,
  template: templatesReducer,
  user: usersReducer,
  viewport: viewportReducer,
  feedback: feedbackReducer,
  coupon: couponsReducer,
  test: testsReducer,
  graph: graphReducer,
  competency: competenciesReducer,
  business: businessesReducer,
  voucher: vouchersReducer,
  buser: busersReducer,
})

const rootReducer = (state, action) => {
  // console.log(action.type)
  if (action.type === 'CLEAR_APP_STATE') {
    state=undefined
  }

  return appReducer(state, action)
}

export default rootReducer



// WEBPACK FOOTER //
// ./src/js/reducers/index.js